import ChangePasswordForm from 'app/form/ChangePasswordForm';
import React from 'react';

const ChangePasswordSection = () => {
	return (
		<div>
			<ChangePasswordForm />
		</div>
	);
};

export default ChangePasswordSection;
